import React from "react"
import GigsPage from "../components/GigsPage";

function Gigs(props) {
  return (
    <div>
        <GigsPage />
      
    </div>
  )
};

export default Gigs;
